<template>
	<div class="contain">
		<div class="heard">
			<van-notice-bar background="#333" color="#fff" scrollable text="欢迎加盟洗乐猫校园智能洗衣 校园洗衣招商加盟热线： 400-005-3383" />
		</div>
		<!-- 标签页 -->
		<div class="tab">
			<div class="tab_one">
				<img src="../assets/img/showImg.png" />
			</div>
			<div class="tab_two">
				<router-link to="/" target="_blank" class="tab_s">
					<p>首页</p>
				</router-link>
				<!-- <p class="tab_three">关于我们</p> -->
				<router-link to="/produce" target="_blank" class="tab_three">
					<p>产品介绍</p>
				</router-link>
				<router-link to="/join" target="_blank" class="tab_three">
					<p>加盟我们</p>
				</router-link>
				<router-link to="/contact" target="_blank" class="tab_three">
					<p>联系我们</p>
				</router-link>
				<!-- <p class="tab_three">品牌动态</p>
				<p class="tab_three">网站地图</p> -->
			</div>
		</div>
		<!-- 轮播图 -->
		<div class="swipt">
			<van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
				<van-swipe-item><img src="../assets/img/swiptt.png"></van-swipe-item>
				<van-swipe-item><img src="../assets/img/swipto.png"></van-swipe-item>
			</van-swipe>
		</div>

		<!-- 品牌简介 -->
		<div class="con">
			<div class="wenzi">BRAND PROFILE</div>
			<!-- 分割线 -->
			<div class="divider">
				<van-divider :style="{ color: '#C0917C', borderColor: '#7D7D7D', padding: '0 16px' }">
					品牌简介
				</van-divider>
			</div>
			<div class="list">
				<div class="list_one">
					<p><strong>洗乐猫校园智能洗衣</strong>隶属于合肥优洗智能科技有限公司，是一种全新的无接触校园智能洗衣模式，它采用公司自主研发的“共享智能洗衣柜+智能洗衣房”洗衣方案。学生只需“一送一取”，24h内即可取回洁净、干爽的衣物。洗乐猫立足十亿校园洗衣蓝海市场，让更多在校学生享受高品质、现代化的校园智能洗衣服务。
					</p>
					<p>
						洗乐猫开创性地研发了智能洗衣收发技术、智能分拣划价技术、智能杀菌消毒一体化技术、智能云钱包管控技术、o2o洗衣预处理技术、智能洗衣营销互动平台、云端售后服务平台等。强大的技术手段，加上多年校园智能洗衣运营经验，让校园洗衣服务更加智能化、标准化、数字化、可视化，较其他校园洗衣模式，洗乐猫更符合当今校园环境与学生生活，勘称校园智洗时代的领军者。
					</p>
				</div>
				<div class="list_two">
					<img src="../assets/img/room.png" />
				</div>
			</div>
			<div class="list_three">了解详情</div>
		</div>
		<!-- 核心亮点 -->

		<div class="con">
			<div class="wenzi">CORE HIGHLIGHTS</div>
			<!-- 分割线 -->
			<div class="divider">
				<van-divider :style="{ color: '#C0917C', borderColor: '#7D7D7D', padding: '0 16px' }">
					核心亮点
				</van-divider>
			</div>
			<div class="more">更多>></div>
			<!-- 宫格 -->
			<div class="gird">
				<van-grid :border="false" :column-num="4">
					<van-grid-item>
						<img src="../assets/img/shengxin.png" />
						<p>烘干杀菌 即取即穿</p>
					</van-grid-item>
					<van-grid-item>
						<img src="../assets/img/bianjie.png" />
						<p>存取两步 轻松洗衣</p>
					</van-grid-item>
					<van-grid-item>
						<img src="../assets/img/gaoxiao.png" />
						<p>24小时内完成存洗取</p>
					</van-grid-item>
					<van-grid-item>
						<img src="../assets/img/huanbao.png" />
						<p>节约水电 共建绿色校园</p>
					</van-grid-item>
				</van-grid>
			</div>
		</div>
		<!-- 产品介绍 -->
		<div class="con">
			<div class="wenzi">PRODUCT INTRODUCTION</div>
			<!-- 分割线 -->
			<div class="divider">
				<van-divider :style="{ color: '#C0917C', borderColor: '#7D7D7D', padding: '0 16px' }">
					产品介绍
				</van-divider>
			</div>
			<div class="more">
				<router-link to="/produce" target="_blank" class="more_one">更多>></router-link>
			</div>
			<!-- 宫格 -->
			<div class="gird_one">
				<van-grid :border="false" :column-num="4">
					<van-grid-item>
						<img src="../assets/img/index_quyigui.png" />
						<p>智能洗衣柜</p>
					</van-grid-item>
					<van-grid-item>
						<img src="../assets/img/index_huajiaji.png" />
						<p>智能划价机</p>
					</van-grid-item>
					<van-grid-item>
						<img src="../assets/img/index_shouyigui.png" />
						<p>收衣柜</p>
					</van-grid-item>
				</van-grid>
			</div>
		</div>
		<!-- 合作案例 -->
		<div class="con">
			<div class="wenzi">PRODUCT INTRODUCTION</div>
			<!-- 分割线 -->
			<div class="divider">
				<van-divider :style="{ color: '#C0917C', borderColor: '#7D7D7D', padding: '0 16px' }">
					合作案例
				</van-divider>
			</div>
			<div class="mores">
				<router-link to="/case" target="_blank">更多>></router-link>
			</div>
			<!-- 宫格 -->
			<div class="gird_two">
				<van-grid :border="false" :column-num="3">
					<van-grid-item>
						<img src="../assets/img/hefei.png" />
						<p>合肥顶峰培训教育学校</p>
					</van-grid-item>
					<van-grid-item>
						<img src="../assets/img/anhui.png" />
						<p>安徽省广德实验中学</p>
					</van-grid-item>
					<van-grid-item>
						<img src="../assets/img/hubei.png" />
						<p>湖北省武汉西藏中学</p>
					</van-grid-item>
					<van-grid-item>
						<img src="../assets/img/sichuan.png" />
						<p>四川绵阳芦溪中学</p>
					</van-grid-item>
					<van-grid-item>
						<img src="../assets/img/hebei.png" />
						<p>河北衡水湖城中学</p>
					</van-grid-item>
					<van-grid-item>
						<img src="../assets/img/guangxi.png" />
						<p>广西钦州灵山武利中学</p>
					</van-grid-item>
				</van-grid>
			</div>
		</div>
		<!-- 品牌动态 -->
		<div class="con">
			<div class="wenzi">PRODUCT INTRODUCTION</div>
			<!-- 分割线 -->
			<div class="divider">
				<van-divider :style="{ color: '#C0917C', borderColor: '#7D7D7D', padding: '0 16px' }">
					品牌动态
				</van-divider>
			</div>
			<div class="more">更多>></div>
			<!-- 宫格 -->
			<div class="box">
				<div class="boxs">
					<span><img src="http://www.xilmao.com/images/new_li_bg.png">回顾2021 洗乐猫与你一起见证校园生活的美好</span>
					<span>2021-12-31</span>
				</div>
				<div class="boxs">
					<span><img src="http://www.xilmao.com/images/new_li_bg.png">各地中小学进入期末备考季 洗乐猫助你做好时间管理</span>
					<span>2021-12-22</span>
				</div>
				<div class="boxs">
					<span><img src="http://www.xilmao.com/images/new_li_bg.png">寒冬季节保护双手 从体验洗乐猫校园智能洗衣开始</span>
					<span>2021-12-15</span>
				</div>
				<div class="boxs">
					<span><img src="http://www.xilmao.com/images/new_li_bg.png">洗乐猫实现全新技术升级 保障优质的校园智能洗衣服务</span>
					<span>2021-12-09</span>
				</div>
				<div class="boxs">
					<span><img src="http://www.xilmao.com/images/new_li_bg.png">2021年的最后一个月 无接触校园洗衣仍为你保驾护航</span>
					<span>2021-12-02</span>
				</div>
				<div class="boxs">
					<span><img src="http://www.xilmao.com/images/new_li_bg.png">一位同学对写给洗乐猫的信：感恩陪我度过逐梦岁月</span>
					<span>2021-11-25</span>
				</div>
				<div class="boxs">
					<span><img src="http://www.xilmao.com/images/new_li_bg.png">冬季校园健康小贴士：洗衣保暖就找洗乐猫校园智洗</span>
					<span>2021-11-17</span>
				</div>
				<div class="boxs">
					<span><img src="http://www.xilmao.com/images/new_li_bg.png">防控疫情洗乐猫在行动 六重“消杀”措施保障学生健康</span>
					<span>2021-11-11</span>
				</div>
			</div>
		</div>
		<div class="box_one">
			<p>关于我们<span>|</span>产品介绍<span>|</span>加盟我们<span>|</span>联系我们<span>|</span>品牌动态<span>|</span>网站地图</p>
			<p>公司地址：安徽省合肥市蜀山区潜山路320号新华国际广场B座 联系电话：400-005-3383 QQ：305693722</p>
			<p>版权所有：合肥优洗智能科技有限公司 Copyright © 2017-2018 <img src="../assets/img/z-07.png">皖ICP备18024180号-1</p>
			<p>投资有风险，招商需谨慎</p>
		</div>
		<div class="bottom">
			<p>交换友情链接请联络QQ：2415381121</p>
			<p>本站关键词：校园洗衣加盟,校园洗衣房,智能洗衣柜,洗乐猫校园智能洗衣加盟</p>
		</div>
		<!-- 加盟喜乐猫 -->
		<!-- <div class="fix">
			<div>
				<p><img src="http://www.xilmao.com/images/suspend_bg.png"></p>
				<p>加盟喜乐猫</p>
				<p>400-005-3383</p>
			</div>
			<div>
				<p>QQ咨询</p>
				<p>联系电话</p>
				<p>公司地址</p>
				<p>品牌动态</p>
				<p>关于我们</p>
			</div>
		</div> -->
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		}
	}
</script>

<style scoped lang="scss">
	* {
		margin: 0;
		padding: 0;
	}

	.contain {
		min-width: 1260px;
		min-height: 100%;
		background: #ffffff;
		box-sizing: border-box;
		margin: auto;

		.heard {
			/deep/ .van-notice-bar {
				height: 20px;
			}
		}

		.tab {
			width: 1260px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 200px 0 200px;
			box-sizing: border-box;
			margin: auto;

			.tab_one {
				width: 150px;
				height: 100px;

				img {
					width: 100%;
					height: 100%;
					object-fit: contain;
				}
			}

			.tab_two {
				width: 60%;
				display: flex;
				justify-content: space-around;
				font-size: 16px;

				.tab_s {
					padding-bottom: 3px;
					border-bottom: 2px solid #FF7800;
					cursor: pointer;
					color: #FF7800;
				}
			}

			.tab_three {
				color: #333;
			}

			.tab_three:hover {
				cursor: pointer;
				color: #FF7800;
				padding-bottom: 3px;
				border-bottom: 2px solid #FF7800;
			}
		}

		.swipt {
			width: 100%;
			object-fit: contain;

			img {
				width: 100%;
				height: 100%;
			}
		}

		.con {
			width: 1260px;
			box-sizing: border-box;
			margin: auto;

			.wenzi {
				padding-top: 20px;
				text-align: center;
				box-sizing: border-box;
				font-size: 10px;
				color: #FF8D00;
			}

			.divider {
				padding-top: 15px;

				/deep/ .van-divider {
					width: 15%;
					font-size: 20px;
					margin: auto;
				}
			}

			.list {
				display: flex;
				justify-content: space-around;
				align-items: center;
				box-sizing: border-box;
				padding: 0 200px 0 100px;
				margin-top: -70px;

				.list_one {
					width: 56%;
					text-indent: 2em;
				}

				.list_two {
					width: 400px;
					height: 400px;

					img {
						width: 100%;
						height: 100%;
						object-fit: contain;
					}
				}
			}

			.list_three {
				width: 50px;
				background: #009688;
				padding: 5px;
				font-size: 12px;
				color: #fff;
				margin: -80px 0 0 115px;

			}

			.list_three:hover {
				background: #33ABA0;
				cursor: pointer;
			}
		}

		.more {
			width: 10%;
			padding: 0 0 0px 80%;

			.more_one {
				color: #333;
			}

			.more_one:hover {
				cursor: pointer;
				color: #777777;
			}

		}

		.gird {
			display: flex;
			justify-content: space-around;
			font-size: 15px;
			color: #7C7C91;
			margin-right: 110px;
			line-height: 2;
		}

		.gird_one {
			display: flex;
			justify-content: space-around;
			font-size: 15px;
			color: #7C7C91;
			margin-right: 110px;
			line-height: 4;
		}

		.gird_two {
			display: flex;
			justify-content: space-around;
			font-size: 15px;
			color: #7C7C91;
			margin-right: 110px;
			line-height: 2;

			/deep/ .van-grid-item__content--center {
				padding: 0;
			}
		}

		.mores {
			width: 10%;
			padding: 0px 0px 0 80%;
			margin-bottom: 30px;

			a {
				color: #333;
			}

			a:hover {
				cursor: pointer;
				color: #777777;
			}
		}

		.box {
			margin-bottom: 30px;

			.boxs {
				width: 100%;
				display: flex;
				justify-content: space-between;
				align-items: center;
				box-sizing: border-box;
				padding: 20px 200px 0 80px;
				font-size: 15px;

				img {
					margin-right: 3px;
				}
			}
		}

		.box_one {
			background-color: #fff;
			height: auto;
			width: 100%;
			padding: 18px 0;
			color: #666;
			box-shadow: 0 0 8px #ccc;
			line-height: 2;
			border-top: 1px solid #ccc;
			text-align: center;
			font-size: 15px;
			box-sizing: border-box;
			margin-bottom: -10px;

			p:nth-child(1) {
				a {
					color: #666;
				}

				a:hover {
					cursor: pointer;
					color: #333;
				}

				span {
					padding-left: 10px;
					letter-spacing: 10px;
				}

			}
		}

		.bottom {
			width: 100%;
			box-sizing: border-box;
			background-color: #848484;
			padding: 5px 0;
			font-size: 15px;
			color: #ffffff;
			text-align: center;
			line-height: 2;
		}

	}

	.fix {
		div:nth-child(1) {
			position: fixed;
			top: 230px;
			right: 10px;
			line-height: 2;

			p:nth-child(2) {
				position: fixed;
				top: 280px;
				right: 70px;
				font-size: 20px;
				color: #6FCFF7;
			}

			p:nth-child(3) {
				position: fixed;
				top: 305px;
				right: 50px;
				font-size: 22px;
				color: #333;
			}
		}

		div:nth-child(2) {
			p {
				width: 80px;
				background: #2FBAF4;
				font-size: 13px;
				padding: 5px 0 5px 30px;
				border-radius: 10px;
				color: white;
				animation-name: around;
				animation-duration: 5s;
				animation-timing-function: ease-in-out;
				animation-delay: 0s;
				animation-iteration-count: infinite;
			}

			@keyframes around {
				0% {
					transform: translateX(0);
				}

				25% {
					transform: translateX(10px);
				}

			}

			p:nth-child(1) {
				position: fixed;
				top: 360px;
				right: 70px;
			}

			p:nth-child(2) {
				position: fixed;
				top: 400px;
				right: 40px;
				animation-name: around;
				animation-duration: 5.2s;
				animation-timing-function: ease-in-out;
				animation-delay: 0s;
				animation-iteration-count: infinite;
			}

			p:nth-child(3) {
				position: fixed;
				top: 440px;
				right: 20px;
			}

			p:nth-child(4) {
				position: fixed;
				top: 480px;
				right: 60px;
				animation-name: around;
				animation-duration: 5.2s;
				animation-timing-function: ease-in-out;
				animation-delay: 0s;
				animation-iteration-count: infinite;
			}

			p:nth-child(5) {
				position: fixed;
				top: 520px;
				right: 40px;
			}
		}
	}
</style>
